import { Link } from 'react-router-dom';

// Cache-bust so hosts/browsers (LiteSpeed max-age ~7 days) pick up logo replacements
const LOGO = '/assets/img/twa-logo.png?v=20261013';

function BrandLogo({ variant = 'dark', to = '/', className = '' }) {
  return (
    <Link
      to={to}
      className={`twa-brand twa-brand--${variant} ${className}`.trim()}
      aria-label="Travel With Ammar"
    >
      <img
        src={LOGO}
        alt="Travel With Ammar — Travel Wander Explore"
        className="twa-brand__img"
        width="152"
        height="100"
        decoding="async"
        sizes="(max-width: 575px) 112px, (max-width: 991px) 128px, 152px"
      />
    </Link>
  );
}

export default BrandLogo;
